import { Actions } from './search-results.actions'
import { fromJS } from 'immutable'
import * as SearchTypes from './search-results.types'

export const initialState = fromJS<any>({
  isLoading: false,
  total: 0,
  queryParams: {
    page: 1,
    page_size: 20,
    type: '',
    keyword: '',
  },
  data: [],
})

export function searchReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case SearchTypes.FETCH_SEARCH_RESULTS_REQUEST: {
      return state.set('isLoading', true)
    }

    case SearchTypes.FETCH_SEARCH_RESULTS_SUCCESS: {
      return state
        .set('isLoading', false)
        .set('total', fromJS(action.payload.filteredCount))
        .set('data', fromJS(action.payload.results))
    }

    case SearchTypes.FETCH_SEARCH_RESULTS_FAILURE: {
      return state.set('isLoading', false)
    }

    case SearchTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case SearchTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
